import styled from "styled-components";
import breakpoints from "../../../styles/breakpoints";

export const EllipsisTag = styled.div`
  align-items: center;
  margin: 0 5px 8px 0;
  white-space: nowrap;
  padding: 1px 7px;
  border-radius: 1rem;
  background-color: ${(props) => props.color};
  max-height: 20px !important;
  max-width: 100% !important;
`;

export const EllipsisTagText = styled.p`
  height: 19px;
  font-size: 10px;
  line-height: 18px;
  flex-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-weight: 600;
  align-items: center;
  text-transform: uppercase;
  ${breakpoints.mdDown} {
    font-size: 10px;
  }
  ${breakpoints.smDown} {
    font-size: 9px;
  }
`;

const Tag = styled.span`
  display: flex;
  align-items: center;
  text-transform: uppercase;

  & span {
    background-color: ${(props) => props.color};
    padding: 4px 18px;
    border-radius: 1rem;
    font-size: 10px;
    font-weight: 600;
  }
`;

export default Tag;
